import React from 'react';
import { stats } from '../data/content';
export function StatsBar() {
  return <section className="w-full border-y border-foreground/10 bg-surface py-10 sm:py-14" data-id="element-201" data-mp="1tai2pb8gatrc">
      <dl className="mx-auto grid max-w-6xl grid-cols-2 gap-y-8 px-5 md:grid-cols-4 md:gap-y-0" data-id="element-202" data-mp="1t8nki4okdfqy">
        {stats.map((stat, index) => <div key={stat.label} className={`px-4 text-center ${index > 0 ? 'md:border-l md:border-foreground/10' : ''}`} data-id="element-203" data-mp="1jctyluoyg9wi" data-mpi={index}>
            <dt className="sr-only" data-id="element-204" data-mp="1ee950e47koh1">{stat.label}</dt>
            <dd data-id="element-205" data-mp="19misc1hstomg">
              <span className="block font-display text-4xl font-black text-foreground sm:text-5xl" data-id="element-206" data-mp="19lzaeks5f08f">
                {stat.value}
              </span>
              <span className="mt-1.5 block text-[10px] font-bold uppercase tracking-[0.16em] text-foreground/45 sm:text-[11px]" data-id="element-207" data-mp="15l5mvsimbng2">
                {stat.label}
              </span>
            </dd>
          </div>)}
      </dl>
    </section>;
}